import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Card, Row, Col, Button } from 'react-bootstrap';
import FalconCloseButton from 'components/common/FalconCloseButton';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';

/**
 * Modal para mostrar la lista de productos y permitir agregarlos al carrito
 */
const ModalProductos = ({ 
    show, 
    onHide, 
    productos, 
    onAgregarProducto,
    onAgregarRenovacion 
}) => {
    const columns = [
        {
            accessor: 'none',
            Header: '',
            Cell: rowData => {
                const { iTipoPago } = rowData.row.original;
                return (
                    <Row className="flex-end-center">
                        <Col xs="auto">
                            <Button
                                variant="primary"
                                size="sm"
                                onClick={() => {
                                    // Si es un producto de renovación (iTipoPago === 2), abrir modal
                                    if (iTipoPago === 2) {
                                        onAgregarRenovacion(rowData.row.original);
                                    } else {
                                        // Si no es renovación, agregar directamente
                                        onAgregarProducto(rowData.row.original);
                                    }
                                }}
                            >
                                +
                            </Button>
                        </Col>
                    </Row>
                );
            }
        },
        {
            accessor: 'idProducto',
            Header: 'ID',
            cellProps: { className: 'ps-1' },
            Cell: rowData => {
                const { idProducto } = rowData.row.original;
                return <b>{idProducto}</b>;
            }
        },
        {
            accessor: 'vCodigoBarras',
            Header: 'Codigo Barras',
            cellProps: { className: 'ps-1' },
            Cell: rowData => {
                const { vCodigoBarras } = rowData.row.original;
                return <b>{vCodigoBarras}</b>;
            }
        },
        {
            accessor: 'vNombreProducto',
            Header: 'Nombre del producto',
            cellProps: { className: 'ps-1' },
            Cell: rowData => {
                const { vNombreProducto } = rowData.row.original;
                return <span title={vNombreProducto} className="text-wrap">{vNombreProducto}</span>;
            }
        },
        {
            accessor: 'iTipoPago',
            Header: 'Tipo de Pago',
            cellProps: { className: 'ps-1' },
            Cell: rowData => {
                const { iTipoPago } = rowData.row.original;
                const tipoPagoTexto = iTipoPago === 1 ? 'Pago \u00FAnico' : iTipoPago === 2 ? 'Renovaci\u00F3n' : iTipoPago;
                return <span title={tipoPagoTexto} className="text-wrap">{tipoPagoTexto}</span>;
            }
        },
        {
            accessor: 'dTotal',
            Header: 'Total',
            cellProps: { className: 'ps-1 text-center' },
            headerProps: { className: 'text-center' },
            Cell: rowData => {
                const { dTotal, vMoneda } = rowData.row.original;
                return (
                    <code>
                        ${parseFloat(dTotal).toLocaleString("es-MX", {
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2
                        })} {vMoneda}
                    </code>
                );
            }
        }
    ];

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            backdrop="static"
            aria-labelledby="modal-productos-title"
        >
            <Modal.Header>
                <Modal.Title id="modal-productos-title">
                    Lista de productos y servicios
                </Modal.Title>
                <FalconCloseButton 
                    className="btn btn-circle btn-sm transition-base p-0" 
                    onClick={onHide} 
                />
            </Modal.Header>
            <Modal.Body style={{ padding: "0px" }}>
                <AdvanceTableWrapper
                    columns={columns}
                    data={productos}
                    sortable
                    pagination
                    perPage={10}
                >
                    <Card>
                        <Card.Header />
                        <Card.Body className="p-0">
                            <Row className="flex-end-center mb-3">
                                <Col sm={8} lg={4}>
                                    <AdvanceTableSearchBox table />
                                </Col>
                            </Row>
                            <AdvanceTable
                                table
                                headerClassName="bg-200 text-900 text-nowrap align-middle"
                                rowClassName="align-middle white-space-nowrap"
                                tableProps={{
                                    size: 'sm',
                                    striped: true,
                                    hover: true,
                                    className: 'fs--1 mb-0 overflow-hidden'
                                }}
                            />
                        </Card.Body>
                        <Card.Footer>
                            <AdvanceTableFooter
                                rowCount={productos.length}
                                table
                                rowInfo
                                navButtons
                                rowsPerPageSelection
                            />
                        </Card.Footer>
                    </Card>
                </AdvanceTableWrapper>
            </Modal.Body>
        </Modal>
    );
};

ModalProductos.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    productos: PropTypes.arrayOf(PropTypes.shape({
        idProducto: PropTypes.number.isRequired,
        vCodigoBarras: PropTypes.string.isRequired,
        vNombreProducto: PropTypes.string.isRequired,
        dPrecioUnitario: PropTypes.number.isRequired,
        dIVA: PropTypes.number.isRequired,
        dTotal: PropTypes.number.isRequired,
        vTipoProducto: PropTypes.string,
        iTipoPago: PropTypes.number.isRequired
    })).isRequired,
    onAgregarProducto: PropTypes.func.isRequired,
    onAgregarRenovacion: PropTypes.func.isRequired
};

export default ModalProductos;
